<template>
  <div class="room-call-sub-video-component">
    <div class="room-call-sub-video" :class="subVideoState">
      <div class="room-call-sub-video-contents">
        <button class="room-call-sub-video-button" @click="onClickSubVideoControl"></button>
        <div class="sub-video-container">
          <video muted autoplay playsinline class="sub-video" />
          <div class="sub-video-cover">
            <p class="user-nickname me volume-on">Guest49</p>
            <div class="mic-state"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomCallSubVideo',
  data() {
    return {
      subVideoState: 'center',
    }
  },
  methods: {
    onClickSubVideoControl() {
      if (this.subVideoState === 'center') {
        this.subVideoState = 'right'
      } else if (this.subVideoState === 'right') {
        this.subVideoState = 'hide'
      } else if (this.subVideoState === 'hide') {
        this.subVideoState = 'center'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-call-sub-video-component {}
.room-call-sub-video {
  height: 108px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  bottom: 12px;
  left: 0;
  &.right {
    justify-content: flex-end;
    .sub-video-container {
      border: 0;
    }
  }
  &.hide {
    justify-content: flex-end;
    .room-call-sub-video-button {
      background: rgba(0, 0, 0, 0.9) url('~@/assets/images/arrowLineThickLeft_white.svg') no-repeat center right 15px / 14px auto;
    }
    .sub-video-container {
      display: none;
    }
  }
}
.room-call-sub-video-contents {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  pointer-events: none;
}
.room-call-sub-video-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.9) url('~@/assets/images/arrowLineThickRight_white.svg') no-repeat center right 12px / 14px auto;
  pointer-events: auto;
  opacity: 0.3;
  &:hover {
    background-color: $mainColor !important;
    opacity: 1;
  }
}
.sub-video-container {
  width: 192px;
  height: 100%;
  margin-left: 8px;
  border: 1px solid #fff;
  position: relative;
  background-color: #000;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
  pointer-events: auto;
}
.sub-video {
  width: 100%;
  height: 100%;
}
.sub-video-cover {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.user-nickname {
  min-width: 120px;
  border-radius: 20px;
  padding: 0 12px;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  line-height: 24px;
  text-align: center;
  position: absolute;
  bottom: 8px;
  &.volume-on {
    background: $mainColor;
  }
  &.me {
    color: yellow;
  }
}
.mic-state {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fa3250 url('~@/assets/images/mic_off_white.svg') no-repeat center / 14px auto;
  position: absolute;
  right: 8px;
  bottom: 8px;
}
</style>